var _rect, _path, _circle, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 5,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 5H7C5.89543 5 5 5.89543 5 7V26C5 27.1046 5.89543 28 7 28H48C49.1046 28 50 27.1046 50 26V7C50 5.89543 49.1046 5 48 5Z",
    fill: "#D9D9D9",
    stroke: "#F5F5F5",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 12.5,
    r: 2.5,
    fill: "#B8B6B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20.1818V26C6 26.5523 6.44772 27 7 27H48C48.5523 27 49 26.5523 49 26V17.2597L42.2826 12.7406C41.6155 12.2917 40.7444 12.2861 40.0715 12.7262L29.6328 19.5539C29.0382 19.9428 28.2819 19.987 27.646 19.6701L19.316 15.519C18.8029 15.2633 18.2048 15.2401 17.6734 15.4553L6 20.1818Z",
    fill: "#B8B6B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 33.5C5 32.6716 5.67157 32 6.5 32H48.5C49.3284 32 50 32.6716 50 33.5C50 34.3284 49.3284 35 48.5 35H6.5C5.67157 35 5 34.3284 5 33.5Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 38.5C5 37.6716 5.67157 37 6.5 37H48.5C49.3284 37 50 37.6716 50 38.5C50 39.3284 49.3284 40 48.5 40H6.5C5.67157 40 5 39.3284 5 38.5Z",
    fill: "#F5F5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 43.5C5 42.6716 5.67157 42 6.5 42H39.5C40.3284 42 41 42.6716 41 43.5C41 44.3284 40.3284 45 39.5 45H6.5C5.67157 45 5 44.3284 5 43.5Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/IMAGE.310e82cacdc3e3d319b8372261505956.svg";
export { ForwardRef as ReactComponent };